import React from "react";
import { isRouteErrorResponse, useRouteError } from "react-router-dom";

const RouteErrorBoundary: React.FC = () => {
  const error = useRouteError();

  let title = "Something went wrong";
  let message = "The page crashed unexpectedly. Please reload and try again.";

  if (isRouteErrorResponse(error)) {
    title = `${error.status} ${error.statusText || "Error"}`;
    message = typeof error.data === "string" ? error.data : message;
  } else if (error instanceof Error) {
    message = error.message || message;
  }

  return (
    <div
      style={{
        minHeight: "100vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px",
        background: "#f7f7f7",
      }}
    >
      <div
        style={{
          width: "100%",
          maxWidth: "620px",
          background: "#fff",
          borderRadius: "12px",
          padding: "24px",
          boxShadow: "0 10px 30px rgba(0, 0, 0, 0.08)",
          fontFamily: "inherit",
        }}
      >
        <h2 style={{ margin: "0 0 8px", color: "#d64f40" }}>{title}</h2>
        <p style={{ margin: "0 0 16px", color: "#444" }}>{message}</p>
        <div style={{ display: "flex", gap: "10px" }}>
          <button
            type="button"
            onClick={() => window.location.reload()}
            style={{
              border: "none",
              background: "#ec6f63",
              color: "#fff",
              padding: "10px 16px",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Reload page
          </button>
          <button
            type="button"
            onClick={() => {
              window.location.href = "/";
            }}
            style={{
              border: "1px solid #ddd",
              background: "#fff",
              color: "#333",
              padding: "10px 16px",
              borderRadius: "8px",
              cursor: "pointer",
            }}
          >
            Go home
          </button>
        </div>
      </div>
    </div>
  );
};

export default RouteErrorBoundary;